<div class="btn-group btn-group-toggle" role="group">
  @for (method of availablePaymentTypes; track method; let first = $first; let last = $last) {
    <input class="btn-check" type="radio"
      [formControl]="paymentType"
      [value]="method">
      <label class="btn btn-toggle h-auto"
        [for]="paymentType"
        (click)="updatePaymentType(method)"
        (keyup)="updatePaymentType(method)"
               [ngClass]='{
               "btn-toggle-left": first,
               "btn-toggle-right": last,
               "active": paymentType.value === method
               }'>{{ 'common.paymentType.' + method | translate }}</label>
    }
  </div>
